import React from 'react';
import { useSelector } from 'react-redux';
import { State } from '../state/reducers';
import { Account } from '../state/types';

interface RoleBasedAccessProps {
  allowedRoles: string[];
  children: React.ReactNode;
}

const internalRoles = ['Admin', 'Support', 'Auditor', 'Billing'];

export const userHasAccess = (userRole: string, allowedRoles: string[]): boolean => {
  const expandedRoles = allowedRoles.includes('Internal')
    ? [...allowedRoles.filter(role => role !== 'Internal'), ...internalRoles]
    : allowedRoles;

  return expandedRoles.includes(userRole);
};

const RoleBasedAccess: React.FC<RoleBasedAccessProps> = ({ allowedRoles, children }) => {
  const user: Account = useSelector((state: State) => state.accountState.user);
  const hasAccess = userHasAccess(user?.role ?? '', allowedRoles);

  if (!hasAccess) return null;

  return <>{children}</>;
};

export default RoleBasedAccess;
